import { lsLoad } from '../tools/Storage';
import StorageEnum from '../enums/Storage.enum';
import { Permissions } from '../generated/fresh-guard-api';

export default () => {
  const profile = lsLoad(StorageEnum.UserProfile);

  if (profile?.permissions && profile.permissions.length > 0) {
    if (profile.permissions.includes(Permissions.CanEditUser)) {
      return true;
    }
  }

  return false;
};
